// En modo desarrollo, podemos necesitar la ruta para pruebas
export const BASE = true ? 'oneroso' : '';

function buildPathFinalPage(path: string): string {
  return BASE ? `${path}` : `${path}`;
}

// Paginas finales constantes
export const FINANCIED = buildPathFinalPage('financiado');
export const ACCESORIES = buildPathFinalPage('accesorios');
export const CEROKM = buildPathFinalPage('vehiculo-nuevo');
